import { render, staticRenderFns } from "./AiRecordButton.vue?vue&type=template&id=738d39d3&scoped=true"
import script from "./AiRecordButton.vue?vue&type=script&lang=js"
export * from "./AiRecordButton.vue?vue&type=script&lang=js"
import style0 from "./AiRecordButton.vue?vue&type=style&index=0&id=738d39d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738d39d3",
  null
  
)

export default component.exports